import { Helmet } from "react-helmet";

interface CustomHelmetProps {
    title?: string;
    description?: string;
    themeColor?: string;
    twitterImage?: string;
    twitterSite?: string;
    noIndex?: boolean;
    children?: React.ReactNode;
}

const CustomHelmet = (props: CustomHelmetProps) => {
    const { title, description, themeColor, twitterImage, twitterSite, noIndex, children } = props;

    return (
        <Helmet>
            <title>{title ? `${title} / Job Hunter` : "Job Hunter"}</title>
            <meta name="og:title" content={title ? `${title} / Job Hunter` : "Job Hunter"} />

            {/** Description */}
            {description && <meta name="description" content={description} />}
            {description && <meta name="og:description" content={description} />}

            {/** Twitter */}
            <meta name="twitter:title" content={title ? `${title} / Job Hunter` : "Job Hunter"} />
            {description && <meta name="twitter:description" content={description} />}
            <meta name="twitter:card" content="summary" />
            {twitterImage && <meta name="twitter:image" content={twitterImage} />}
            {twitterSite && <meta name="twitter:site" content={twitterSite} />}

            {/** Misc */}
            <link rel="canonical" href={window.location.href} />
            <meta name="og:url" content={window.location.href} />
            {themeColor && <meta name="theme-color" content={themeColor} />}
            {noIndex && <meta name="robots" content="noindex" />}

            {children}
        </Helmet>
    )
}

export default CustomHelmet;